import { LabelUrlDTO } from '.';
import { ResponseDTO } from './response-dto';

export interface SaveUserContextRoleProfileResponseDTO extends ResponseDTO {
    userRoleContextProfileId?: number;
    idbApps?: string;
    idbAppsList?: LabelUrlDTO[];
    roleStatus?: string;
    roleStatusLabel?: string;
    userStatus?: string;
    userStatusLabel?: string;
    canSendAccountActivationLink?: boolean;
    disableAutomaticUpdate?: boolean;
}
